import { IViewerApi } from "@bronte/viewer-api/src/main";

import { getTocForWeb } from "./getTocForWeb";
import { getTocForMobile } from "./getTocForMobile";
import { Toc } from "./types";

export const getCoursewareStructure = (
  viewerApi: IViewerApi,
  isOfflinePackage: boolean,
): Promise<() => Toc> => {
  return isOfflinePackage ? getTocForMobile(viewerApi) : getTocForWeb(viewerApi);
};
